
import { PROFILE_REQUEST, PROFILE_SUCCESS, PROFILE_FAILURE } from './actionTypes';
import { PROFILE_UPDATE_REQUEST, PROFILE_UPDATE_SUCCESS, PROFILE_UPDATE_FAILURE } from './actionTypes';
import {PASSWORD_REQUEST, PASSWORD_SUCCESS, PASSWORD_FAILURE } from './actionTypes';
import authService from '../../services/profileService';




// profil bilgilerini çeker tek kişinin
export const profileRequest = () => ({
  type: PROFILE_REQUEST,
});

export const profileSuccess = (user) => ({
  type: PROFILE_SUCCESS,
  payload: user,
});

export const profileFailure = (error) => ({
  type: PROFILE_FAILURE,
  payload: error,
});

export const GetProfile = (authUserId,token) => {

  return async (dispatch) => {
    dispatch(profileRequest());
    try {
      const response = await authService.getProfile(authUserId,token);
      dispatch(profileSuccess(response.data.data.data[0]));
      return response.data.data.data[0];
    } catch (error) {
      dispatch(profileFailure(error.response?.data || 'Profil alınamadı!'));
      throw error;
    }
  };
};





// kişinin profil bilgilerini günceller
export const profileUpdateRequest = () => ({
  type: PROFILE_UPDATE_REQUEST,
});

export const profileUpdateSuccess = (user) => ({
  type: PROFILE_UPDATE_SUCCESS,
  payload: user,
});

export const profileUpdateFailure = (error) => ({
  type: PROFILE_UPDATE_FAILURE,
  payload: error,
});

export const UpdateProfile = (email,token) => {

  return async (dispatch) => {
    dispatch(profileUpdateRequest());
    try {
      const response = await authService.updateProfile(email,token);
      dispatch(profileUpdateSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(profileUpdateFailure(error.response?.data || 'Profil alınamadı!'));
      throw error;
    }
  };
  
};




export const passwordRequest = () => ({
  type: PASSWORD_REQUEST,
});

export const passwordSuccess = (user) => ({
  type: PASSWORD_SUCCESS,
  payload: user,
});

export const passwordFailure = (error) => ({
  type: PASSWORD_FAILURE,
  payload: error,
});
export const sendPasswordCode = (data,token) => {

  return async (dispatch) => {
    dispatch(passwordRequest());
    try {
      const response = await authService.sendCondePasswordApi(data,token);
      dispatch(passwordSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(passwordFailure(error.response?.data || 'Kod Gönderilemedi!'));
      throw error;
    }
  };
  
};
export const passwordChangeRequest = () => ({
  type: PASSWORD_REQUEST,
});

export const passwordChangeSuccess = (user) => ({
  type: PASSWORD_SUCCESS,
  payload: user,
});

export const passwordChangeFailure = (error) => ({
  type: PASSWORD_FAILURE,
  payload: error,
});
export const passwordChange = (data,token) => {

  return async (dispatch) => {
    dispatch(passwordChangeRequest());
    try {
      const response = await authService.changePasswordApi(data,token);
      dispatch(passwordChangeSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(passwordChangeFailure(error.response?.data || 'Kod Gönderilemedi!'));
      throw error;
    }
  };
  
};


  
